import React, { useState, useEffect } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RecordNotFoundNoNotification from "../../../common/RecordNotFoundNoNotification";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../common/LoadingContext";
import { useNotificationContext } from "../../../common/NotificationContext";
import { getTechDocListService } from "../../../services/TechnicalDocumentService";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const TechDoc = (props) => {
  const {
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
  } = props;
  const [brodcastList, setBrodcastList] = useState([]);

  useEffect(() => {
    setBrodcastList(notificationRecords);
  }, [
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
  ]);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const viewTechDocList = async (value) => {
    try {
      setLoading(true);
      var requestBody = [];
      requestBody.push(value);
      const response = await getTechDocListService(requestBody);
      if (response.statusCode === 6) {
        navigate(`/technical-document-view`, {
          state: { content: response, isUnRead: true, sorting: true,pageNo: page,
            typeId: 3,isFromRead : true },
        });
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to service doc list");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {brodcastList && brodcastList.length > 0 ? (
        brodcastList
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <Accordion
                sx={{
                  borderLeft: 7,
                  p: 0,
                  borderColor: "#003f93",
                  mb: 1,
                  textAlign: "left",
                }}
                key={row.id}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ textTransform: "capitalize" }}>
                    {row.title}{" "}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{row.content}</Typography>
                  <Typography sx={{ textAlign: "right" }}>
                    <ArrowRightAltIcon
                      fontSize="large"
                      sx={{ color: "#003f93", cursor: "pointer" }}
                      onClick={() => viewTechDocList(row.notificationTypeId)}
                    />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })
      ) : (
        <RecordNotFoundNoNotification />
      )}
    </>
  );
};

export default TechDoc;
